import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useTheme } from "@mui/material/styles";
import { useMaterialUIController } from "context";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Button,
  MenuItem,
  Paper,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { BASE_URL, IMAGE_URL } from "network";

export default function Tables({
  tabs = [],
  title,
  handleSearch,
  filterData,
  totalPages,
  data,
  columns,
  changePage,
  handleChangeCheckbox,
  onEdit,
  clickModal,
  clickButton,
  handleDelete,
  onTabClick,
  
}) {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedFilter, setSelectedFilter] = useState("");

  // 🔹 Filter table data locally
  const filteredTableData = selectedFilter
    ? data?.filter((row) => row.cityId === selectedFilter)
    : data;

  const handleChangePage = (event, newPage) => {
    changePage(newPage, rowsPerPage);
    setPage(newPage);
  };

  // const handleChangePage = (event, newPage) => {
  //   changePage(newPage, rowsPerPage);
  //   setPage(newPage);
  // };

  const handleChangeRowsPerPage = (event) => {
    const newValue = parseInt(event.target.value, 10);
    setRowsPerPage(newValue);
    setPage(0);
    changePage(0, newValue);
  };

  const handleSearchChange = (event) => {
    handleSearch(event.target.value);
    setSearchTerm(event.target.value);
  };

  const getLimitedText = (text, maxChars) => {
    if (text && typeof text === "string") {
      if (text.length <= maxChars) return text;
      return text.slice(0, maxChars) + "...";
    }
    return text;
  };

  const getTimeOnly = (time) => {
    const date = new Date(time * 1000);
    const timeOnly = date.toTimeString().split(" ")[0];
    return timeOnly || "--";
  };

  function formatDistance(distance) {
    const absDist = Math.abs(distance);
    if (absDist >= 1000) return `${(absDist / 1000).toFixed(2)} km`;
    return `${absDist.toFixed(2)} m`;
  }

  const selectTab = (item, index) => {
    setSelectedTab(index);
    onTabClick?.(index, item);
  };


  const handleCityFilterChange = (cityId) => {
  setSelectedFilter(cityId);
  filterData?.onChange?.(cityId);
};



  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                {title}
              </MDTypography>
            </MDBox>

            {/* {tabs.length > 0 && (
              <MDBox display="flex" gap={2} mt={2}>
                {[{ name: "All" }, ...tabs].map((item, i) => (
                  <Button
                    key={i}
                    variant={selectedTab === i ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => selectTab(item, i)}
                    className={selectedTab === i ? "btn-tab active" : ""}
                  >
                    {item.name}
                  </Button>
                ))}
              </MDBox>
            )} */}

            {(tabs.length > 0 || filterData?.data?.length > 0) && (
  <MDBox
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mt={2}
    mx={2}
  >
    {/* Tabs – LEFT */}
    <MDBox display="flex" gap={2}>
      {[{ name: "All" }, ...tabs].map((item, i) => (
        <Button
          key={i}
          variant={selectedTab === i ? "contained" : "outlined"}
          color="primary"
          onClick={() => selectTab(item, i)}
        >
        {item.name}
        </Button>
      ))}
    </MDBox>

    {/* City Filter – RIGHT */}
    {filterData?.data?.length > 0 && (
      <TextField
        select
        label={`Filter by ${filterData.for}`}
        value={selectedFilter}
        onChange={(e) => handleCityFilterChange(e.target.value)}
        size="small"
        sx={{ minWidth: 220 }}
      >
        <MenuItem value="">All</MenuItem>
        {filterData.data.map((item) => (
          <MenuItem key={item._id} value={item._id}>
            {item[filterData.labelKey]}
          </MenuItem>
        ))}
      </TextField>
    )}
  </MDBox>
)}



            <MDBox pt={3} className="main-section-card">
              {/* Search Field */}
              <TextField
                label="Search here"
                variant="outlined"
                fullWidth
                margin="normal"
                value={searchTerm}
                onChange={handleSearchChange}
              />

                {/* {filterData?.data?.length > 0 && (
                  <TextField
                    select
                    label={`Filter by ${filterData.for}`}
                    value={selectedFilter}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                    size="small"
                    sx={{ minWidth: 200 }}
                  >
                    <MenuItem value="">All</MenuItem>
                    {filterData.data.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.cityName}
                      </MenuItem>
                    ))}
                  </TextField>
            )} */}
              {/* Data Table */}
              <TableContainer component={Paper}>
                <Table stickyHeader>
                  <TableHead className="admin-tables">
                    <TableRow>
                      {columns.map((col) => (
                        <TableCell
                          key={col.key}
                          style={{
                           color: darkMode ? "#fff" : "",
                            padding: "12px 16px",
                            width: col.width || "auto",
                            maxWidth: col.width || "none",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {col.display.charAt(0).toUpperCase() +
                            col.display.slice(1)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data && data.length > 0 ? (
                      data.map((user, index) => (
                        <TableRow key={index} hover>
                          {columns.map((key, i) => (
                            <TableCell
                              key={i}
                              style={{
                                color: darkMode ? key.color ? key.color: "#fff" : key.color ? key.color: "#000",
                                padding: "12px 16px",
                                width: key.width || "auto",
                                maxWidth: key.width || "none",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                verticalAlign: "middle",
                              }}
                            >
                              {/* Checkbox */}
                              {key.type === "checkbox" && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={user[key.key]}
                                      onChange={(e) =>
                                        handleChangeCheckbox(
                                          e,
                                          user._id,
                                          key.key
                                        )
                                      }
                                      color="primary"
                                    />
                                  }
                                  label=""
                                />
                              )}

                              {/* Distance */}
                              {key.type === "distance" &&
                                user[key.key] &&
                                formatDistance(user[key.key])}

                              {/* Time */}
                              {key.type === "time" &&
                                user[key.key] &&
                                getTimeOnly(user[key.key])}

                              {/* Image */}
                              {key.type === "image" && (
                                <img
                                  src={IMAGE_URL + user[key.key]}
                                  crossOrigin="anonymous"
                                  width="60"
                                  height="60"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: 6,
                                    ...(key?.style || {}),
                                  }}
                                />
                              )}

                              {/* Object */}
                              {key.type === "Objects" &&
                                Object.entries(user[key.key] || {}).map(
                                  ([duration, price], i) => (
                                    <div key={i}>
                                      <strong>{duration}</strong>: ₹{price}
                                    </div>
                                  )
                                )}

                              {/* Link */}
                              {key.type === "link" && (
                                <Link to={`${key.route}/${user[key.key]}`}>
                                  {key.display}
                                </Link>
                              )}

                              {/* Display (with tooltip for long Booking IDs) */}
                              {key.type === "display" &&
                                (key.render ? (
                                  key.render(user)
                                  // key.render && user ? key.render(user) : null

                                ) : (
                                  <Tooltip title={user[key.key] || ""}>
                                    <span>
                                      {key?.key2
                                        ? getLimitedText(
                                          user[key.key]?.[key.key2],
                                          25
                                        )
                                        : getLimitedText(user[key.key], 25)}
                                    </span>
                                  </Tooltip>
                                ))}

                              {/* Number */}
                              {key.type === "number" &&
                                Math.round(user[key.key] * 100) / 100}

                              {/* IndexedArray */}
                              {key.type === "IndexedArray" &&
                                user[key.key].map((k, i) => <p key={i}>{k}</p>)}

                              {/* Action */}
                              {/* {key.type === "action" &&
                                key.render &&
                                (key.key === "track"
                                  ? key.render(user, clickModal)
                                  : key.render(user, handleDelete))} */}

                              {key.type === "action" && key.render && (
                                <>
                                  {key.key === "track" && key.render(user, clickModal)}
                                  {key.key === "edit" && key.render(user, onEdit, handleDelete)}
                                </>
                              )}


                              {/* Query String */}
                              {key.type === "query_string" && (
                                <Link to={`${key.route}${user[key.key]}`}>
                                  {key.display}
                                </Link>
                              )}

                              {/* Modal */}
                              {key.type === "modal" && (
                                <Button
                                  onClick={() =>
                                    clickModal(key.for, user[key.key])
                                  }
                                  style={{
                                    color: "#fff",
                                    background: "#338ced",
                                  }}
                                >
                                  {key.display}
                                </Button>
                              )}

                              {/* Button */}
                              {key.type === "button" && (
                                <Button
                                  onClick={() =>
                                    clickButton(
                                      user[key.secondKey],
                                      user[key.key],
                                      "update"
                                    )
                                  }
                                  style={{
                                    color: "#fff",
                                    background: "#338ced",
                                  }}
                                >
                                  {user[key.secondKey]}
                                </Button>
                              )}

                              {/* Select Action */}
                              {key.type === "selectAction" && (
                                <TextField
                                  select
                                  value={
                                    user[key?.key2]
                                      ? user[key.key][key?.key2]
                                      : user[key.key]
                                  }
                                  onChange={(e) =>
                                    key.onSelectChange?.(e, user)
                                  }
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  style={key?.style || {}}
                                >
                                  {(typeof key.options === "function"
                                    ? key.options(user)
                                    : key.options || []
                                  ).map((option, i) => (
                                    <MenuItem key={i} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              <TablePagination
                component="div"
                count={totalPages * rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Rows per page"
                sx={{
                  "& .MuiTablePagination-toolbar": {
                    color: darkMode
                      ? theme.palette.common.white
                      : theme.palette.text.primary,
                  },
                  "& .MuiTablePagination-selectIcon": {
                    color: darkMode
                      ? theme.palette.common.white
                      : theme.palette.text.primary,
                  },
                }}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}



